export default __webpack_public_path__ + "static/media/gray-top-logo-wshadow.fb5f295d.svg";